// extracted by mini-css-extract-plugin
export default {"container":"uF-z","innerContainer":"vF-z","multipleLines":"wF-z","heading":"xF-z","content":"yF-z","linkColor":"zF-z"};